<template>
  <div>
    <h2 id="projectstext" class="bg-black text-white text-4xl md:text-6xl font-bold pb-4 pl-6 md:pl-16">Projects</h2>
    <h2 class="bg-black text-white text-xl md:text-3xl pl-6 md:pl-16 pb-8 md:pb-16 font-bold">
      A handful of applications I'm particularly proud of
    </h2>

    <div class="px-4 grid grid-cols-1 md:grid-cols-2 gap-8 bg-black justify-items-center">
      <!-- CPU Scheduler -->
      <div class="project hover:scale-105 border-2 bg-black border-neutral-800 rounded-xl text-white p-4">
        <img class="mx-auto mt-4 max-w-full md:w-8/12" src="../assets/cpu_scheduler_project.gif" alt="GIF is unable to load" />
        <h1 class="pt-4 text-2xl font-semibold text-center">CPU Scheduler in C</h1>
        <p class="p-4 text-lg text-center">
          Built using C and Python. Simulates CPU scheduling with FIFO, RR, MLFQ, and SJF algorithms. Visualized process execution with graphs.
        </p>
      </div>

      <!-- Space Invaders Clone -->
      <div class="project hover:scale-105 border-2 bg-black border-neutral-800 rounded-xl text-white p-4">
        <img class="mx-auto pt-4 max-w-full md:w-8/12" src="../assets/space_invaders.gif" alt="GIF is unable to load" />
        <h1 class="pt-4 text-2xl font-semibold text-center">Space Invaders Clone</h1>
        <p class="p-4 text-lg text-center">
          Terminal-based Space Invaders clone written in C using the Ncurses library.
        </p>
      </div>

      <!-- Edmonton Transit Map -->
      <div class="project hover:scale-105 border-2 bg-black border-neutral-800 rounded-xl text-white p-4">
        <img class="mx-auto mt-4 max-w-full md:w-6/12" src="../assets/Bus_stops_project_recording.gif" alt="GIF is unable to load" />
        <h1 class="pt-4 text-2xl font-semibold text-center">Edmonton Transit System Map</h1>
        <p class="p-4 text-lg text-center">
          Python app that maps ETS bus routes. Enter a route to draw it, or click the map to show nearby routes.
        </p>
      </div>
    </div>

    <br><br><br>
  </div>
</template>

<style scoped>
.project {
  width: 100%;
  max-width: 42rem;
  background-color: black;
}
</style>
